export const PRIVACY_AR = {
  title: "سياسة الخصوصية",
  version: "1.1",
  updated: "2026-06-15",
  intro:
    "توضّح هذه السياسة أي بيانات تجمعها منصة HELCOO، ولماذا، وكيف نحميها، وما حقوقك. تنطبق على الموقع وتطبيقات iOS و Android. جهة الاتصال بشأن الخصوصية: support@helcoo.uk.",
  sections: [
    {
      h: "1. البيانات التي نجمعها",
      p: [
        "بيانات الحساب: الاسم، البريد الإلكتروني، الهاتف، العنوان الفعلي (سكن الموظف، اختياري يدخله صاحب العمل أو الموظف)، الجنسية وتاريخ الميلاد والحالة الاجتماعية، جهة الاتصال في الطوارئ (اسم ورقم)، الشركة والفرع والدور الوظيفي.",
        "بيانات مالية: رقم الحساب المصرفي IBAN وبيانات الراتب والخصومات والمكافآت — لأغراض الرواتب فقط.",
        "بيانات حيوية: صورة حية للوجه وقالب رقمي مشتق منها. عند التسجيل الأولي تُرسل الصورة إلى AWS Rekognition الذي يُنشئ القالب ويحفظه في مجموعة خاصة بنا (IndexFaces)، ونحفظ عندنا معرّف القالب والصورة المرجعية فقط. وعند كل حضور/انصراف تُرسل الصورة اللحظية إلى Rekognition للمقارنة (CompareFaces/SearchFaces) ثم تُحذف فوراً. تُستخدم حصراً للتحقق من هوية الموظف.",
        "الموقع الجغرافي الدقيق: يُقرأ فقط لحظة تسجيل الحضور/الانصراف للتحقق من النطاق المسموح للفرع.",
        "بيانات الحضور: أوقات الدخول والخروج والتأخير والإضافي والإجازات.",
        "بيانات الجهاز والاستخدام (تُجمع في سجلات الخادم فقط): عنوان IP ومنه الدولة والمدينة، نوع الجهاز/المتصفح، مسار الطلب ورمز الاستجابة وزمن التنفيذ مرتبطاً بحسابك، ورسائل الأخطاء الفنية. ومعرّف إشعارات الجهاز (رمز FCM) مع نوع النظام لإيصال الإشعارات فقط.",
        "لا يحتوي التطبيق على أي أداة تحليلات سلوكية أو تقارير أعطال لأطراف ثالثة (لا Crashlytics ولا Sentry ولا Google Analytics)، ولا يُجمع أي معرّف إعلاني.",
        "مستندات وملفات: هوية وطنية، جواز سفر، عقود، وشهادات طبية يرفعها الموظف لطلبات الإجازة المرضية (بيانات صحية)، ومستندات محاسبية للشركة.",
      ],
    },
    {
      h: "1.1 الشهادات الطبية والبيانات الصحية",
      p: [
        "عند طلب إجازة مرضية قد تُطلب منك شهادة طبية (صورة أو PDF بحد أقصى 2 ميغابايت). تُستخدم حصراً للبتّ في الطلب واحتساب الرصيد والراتب، ولا تُستخدم لأي غرض آخر ولا تُشارك مع أي طرف ثالث ولا تُرسل إلى أي نموذج ذكاء اصطناعي.",
        "تُخزَّن مشفَّرة في مساحة تخزين الشركة (Amazon S3) بمسار خاص بشركتك، والوصول إليها مقصور على الموظف نفسه ومدير الموارد البشرية ومدير الشركة والمدير المباشر المسؤول عن الموافقة. كل وصول يُسجَّل.",
        "تُحفظ ما دامت سجلات الإجازة قائمة (سجل عمل قد تفرضه الأنظمة المحلية)، وتُحذف عند حذف حسابك أو إنهاء الاشتراك. لا يُطلب منك أي تشخيص أو تفاصيل مرضية داخل التطبيق.",
      ],
    },
    {
      h: "2. أساس المعالجة والموافقة",
      p: ["نعالج البيانات لتنفيذ العقد مع الشركة المشتركة، وللمصالح المشروعة في أمن النظام، وللالتزامات القانونية. أما البيانات الحيوية فلا تُعالج إلا بموافقة صريحة ومنفصلة من الموظف، ويمكن سحبها في أي وقت."],
    },
    {
      h: "3. كيف نستخدم البيانات",
      p: ["للتحقق من هوية الموظف عند الحضور، ومنع الاحتيال، وحساب الرواتب والتقارير، وإرسال الإشعارات التشغيلية، وتحسين موثوقية الخدمة وأمنها."],
    },
    {
      h: "4. ما لا نفعله أبداً",
      p: ["لا نبيع بياناتك. لا نستخدم البيانات الحيوية أو الموقع للإعلانات أو التسويق أو التتبع عبر التطبيقات والمواقع. لا نستخدم بياناتك لتدريب أنظمة تعرّف على الوجه لأطراف ثالثة. لا نتتبّع موقعك في الخلفية."],
    },
    {
      h: "5. المشاركة مع مزوّدي الخدمة",
      p: ["نستعين بمزوّدين يعالجون البيانات بالنيابة عنا وبموجب اتفاقيات معالجة: Amazon Web Services (تخزين S3، مطابقة الوجه Rekognition، إرسال البريد SES)، و Stripe لمعالجة المدفوعات. لا يُسمح لهم باستخدام بياناتك لأغراضهم."],
    },
    {
      h: "6. النقل الدولي",
      p: ["قد تُخزَّن البيانات في مراكز بيانات داخل الاتحاد الأوروبي والولايات المتحدة مع ضمانات تعاقدية مناسبة للنقل الدولي."],
    },
    {
      h: "7. مدة الاحتفاظ والحذف",
      p: [
        "تُحفظ سجلات الحضور طوال مدة الاشتراك وبما تقتضيه الأنظمة المحلية. تُحذف قوالب الوجه فوراً عند سحب الموافقة أو إلغاء الحساب. بعد إنهاء الاشتراك تُتاح 30 يوماً للتصدير ثم تُحذف البيانات نهائياً.",
        "لطلب الوصول إلى بياناتك أو تصحيحها أو حذف حسابك بالكامل: راسل support@helcoo.uk وسنستجيب خلال 30 يوماً.",
      ],
    },
    {
      h: "8. الأمن",
      p: ["تشفير الاتصالات عبر HTTPS، تشفير البيانات في التخزين، تجزئة كلمات المرور، صلاحيات مبنية على الأدوار، عزل بيانات كل شركة، سجلات تدقيق، ورموز استعادة لمرة واحدة."],
    },
    {
      h: "9. حقوقك",
      p: ["لك الحق في الوصول والتصحيح والحذف والاعتراض وتقييد المعالجة ونقل البيانات وسحب الموافقة، وفق GDPR وCCPA وما يعادلهما. لن يؤدي استخدام حقوقك إلى تمييز في الخدمة."],
    },
    {
      h: "10. الأطفال",
      p: ["الخدمة موجّهة لبيئات العمل ولا تستهدف من هم دون 16 عاماً، ولا نجمع بياناتهم عن قصد."],
    },
    {
      h: "11. التغييرات والاتصال",
      p: ["سنُشعرك بأي تغيير جوهري في هذه السياسة قبل نفاذه. لأي سؤال أو شكوى بشأن الخصوصية: support@helcoo.uk."],
    },
  ],
};
